// Get the container
const slideContainer9 = document.querySelector('.slide_container9');

// URLs for desktop images
const desktopImageUrls9 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisDesktop_1.gif?v=1721368681',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/2_54129d90-65a1-4b74-8af8-1392b2deb6f8.png?v=1721368728',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/4.png?v=1721368730'
];

// URLs for mobile images
const mobileImageUrls9 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobileB.gif?v=1721371963',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B1.png?v=1721371843',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B3.png?v=1721371842',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B4.png?v=1721371839',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B5.png?v=1721371843',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B6.png?v=1721371843',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B7.png?v=1721371843',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ParisMobile_B9.png?v=1721371843'
];

// Function to determine screen size and load appropriate images
function loadImages9() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainer9.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        // Create and append mobile images
        mobileImageUrls9.forEach(url => {
            const mobileImage = document.createElement('img');
            mobileImage.src = url;
            mobileImage.alt = 'Mobile image';
            mobileImage.className = 'mobile-image9';
            slideContainer9.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        // Create and append desktop images
        desktopImageUrls9.forEach(url => {
            const desktopImage = document.createElement('img');
            desktopImage.src = url;
            desktopImage.alt = 'Desktop image';
            desktopImage.className = 'desktop-image9';
            slideContainer9.appendChild(desktopImage);
        });
    }
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImages9();
    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', loadImages9);

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTime9 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdown9() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTime9 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown9').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown9').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdown9, 1000);
    }

    updateCountdown9();
});
